/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Alternatives_KickerInputs */

const en_directory_alternatives_kicker = /** @type {(inputs: Directory_Alternatives_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternatives`)
};

const zh_directory_alternatives_kicker = /** @type {(inputs: Directory_Alternatives_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`替代方案`)
};

/**
* | output |
* | --- |
* | "Alternatives" |
*
* @param {Directory_Alternatives_KickerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_alternatives_kicker = /** @type {((inputs?: Directory_Alternatives_KickerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Alternatives_KickerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_alternatives_kicker(inputs)
	return zh_directory_alternatives_kicker(inputs)
});
export { directory_alternatives_kicker as "directory.alternatives.kicker" }